import { render, staticRenderFns } from "./CollapseItems1Template.vue?vue&type=template&id=5ec7a906"
import script from "./CollapseItems1Template.vue?vue&type=script&lang=js"
export * from "./CollapseItems1Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports